import { atom, selector } from "recoil";

import { topAddressesAtom } from "../../modules/firebase";

export const explorerOpenAtom = atom({
  key: "explorerOpen",
  default: false,
});

export const searchTermAtom = atom({
  key: "searchTerm",
  default: "",
});

export const searchResultsAtom = atom({
  key: "searchResults",
  default: [],
});

export const searchResultsSelector = selector({
  key: "searchResultsSelector",
  get: ({ get }) => {
    const searchTerm = get(searchTermAtom);
    const searchResults = get(searchResultsAtom);
    const topAddresses = get(topAddressesAtom);
    return searchTerm ? searchResults : topAddresses;
  },
});
